import React from 'react';

const Separator = ({ light }) => (
  <div style={{ width: '100%', height: 1, border: `solid 1px ${light ? '#f0f2f5' : '#ebecf5'}` }} />
);

export default Separator;
